var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenInMapsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5449219,8.1611328c-0.2841797-0.1835938-0.6416016-0.2128906-0.9511719-0.0751953L23,10.5720215v2.1887207l5-2.2216797 v13.8115234l-7,3.1103516V18h-2v9.3818359l-6-3V18h-2v6.3505859l-7,3.1103516V13.6494141l4.5-1.9995117V9.4609375l-5.90625,2.625 C2.2324219,12.2470703,2,12.6044922,2,13v16c0,0.3388672,0.1708984,0.6542969,0.4550781,0.8388672 C2.6201172,29.9453125,2.8095703,30,3,30c0.1376953,0,0.2763672-0.0283203,0.40625-0.0859375l8.5688477-3.8083496 l7.5776367,3.7888184c0.015564,0.0076904,0.0332642,0.0047607,0.0490723,0.0115967C19.7293091,29.961853,19.8627319,30,20,30 c0.1226196,0,0.2424927-0.0308838,0.3583984-0.0758057c0.0155029-0.0059814,0.0325317-0.0033569,0.0478516-0.0101318l9-4 C29.7675781,25.7529297,30,25.3955078,30,25V9C30,8.6611328,29.8291016,8.3457031,29.5449219,8.1611328z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,8c0,3.5341187,4.132019,8.4020386,5.1049805,9.5c0.0669556,0.0755615,0.1201172,0.1347046,0.1547852,0.1728516 C15.4492188,17.8808594,15.7177734,18,16,18s0.5507812-0.1191406,0.7402344-0.3271484 c0.034668-0.038147,0.0878296-0.09729,0.1547852-0.1728516C17.867981,16.4020386,22,11.5341187,22,8c0-3.3085938-2.6914062-6-6-6 S10,4.6914062,10,8z M16,4c2.2060547,0,4,1.7939453,4,4c0,2.15625-2.4472656,5.5830078-4,7.4677734 C14.4472656,13.5830078,12,10.15625,12,8C12,5.7939453,13.7939453,4,16,4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 8,
    r: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInMapsSmall);
export default __webpack_public_path__ + "static/media/open-in-maps--small.2e228c18c7c549bf9bad24252ddaeddf.svg";
export { ForwardRef as ReactComponent };